module.exports = __webpack_public_path__ + "img/login_banner_tab.1d304911.png";